import { useEffect, useState } from "react"
import { Alert, Button, Col, Form, Row, } from "react-bootstrap"
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from "zod"
import { ProfissionaisService } from "../../../services/api/Profissionais/ProfissionaisService"

import { useNavigate, useParams } from "react-router-dom"
import { useHookFormMask } from 'use-mask-input';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Loading from "../../../components/Loader/Loading"
import { usePermissoes } from "../../../hooks/usePermissoes"
import PermissoesComponent from "../../../components/PermissaoComponent"
import { ProfissionaisConfigService } from "../../../services/api/Profissionais/ProfissionaisConfigService"
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons"




const diasSemanaObj = z.object({
    id: z.coerce.string().nullable(),
    diasSemanasId: z.coerce.string().nullable(),
    inicio: z.coerce.string().nullable(),
    termino: z.coerce.string().nullable(),
    status: z.coerce.string().nullable(),
    intervalo: z.coerce.string(),

})


const scheme = z.object({
    qntAtendHorario: z.coerce.string(),
    qntEncaixe: z.coerce.string(),
    permiteAgendaOnline: z.coerce.string(),
    diasSemanas: z.array(diasSemanaObj),
    intervalo: z.coerce.string(),
})

const ProfissionaisAgendaConfig = () => {


    const [disableSalvar, setDisableSalvar] = useState(false)
    const { idProfissional } = useParams();
    const [profissional, setProfissional] = useState(null)
    const [alert, setAlert] = useState({
        variant: '',
        msg: ''
    })
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 4, acoesId: 1 },
        { secoesId: 4, acoesId: 2 },
    ])

    const { register, handleSubmit, watch, setValue, control, formState: { errors } } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(scheme),
        values: profissional
    })
    const registerWithMask = useHookFormMask(register);

    const diasSemanasPadrao = [
        { diasSemanasId: 1, dias_semanas: { nome: 'Segunda' }, intervalo: 30, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 2, dias_semanas: { nome: 'Terça' }, intervalo: 30, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 3, dias_semanas: { nome: 'Quarta' }, intervalo: 30, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 4, dias_semanas: { nome: 'Quinta' }, intervalo: 30, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 5, dias_semanas: { nome: 'Sexta' }, intervalo: 30, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 6, dias_semanas: { nome: 'Sábado' }, intervalo: 30, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 7, dias_semanas: { nome: 'Domingo' }, intervalo: 30, inicio: '08:00', termino: '17:00', status: 1 }
    ]

    //console.log(useParams())

    const onSubmit = async (data) => {

        setDisableSalvar(true)
        let DataForm = data

        let DiasSemanasIntevalo = []
        DataForm.diasSemanas.map((item) => {
            DiasSemanasIntevalo.push({
                ...item,
                intervalo: DataForm.intervalo
            })
        })

        DataForm.diasSemanas = DiasSemanasIntevalo
        const res = await ProfissionaisConfigService.store(idProfissional, DataForm)

        if (res.success) {
            setAlert({
                variant: 'success',
                msg: res.msg
            })
            setDisableSalvar(false)
        } else {
            setAlert({
                variant: 'danger',
                msg: res.msg
            })
            setDisableSalvar(false)

        }



    }


    useEffect(() => {

        if (idProfissional != undefined) {
            const fetchData = async () => {
                setIsloading(true);
                const data = await ProfissionaisConfigService.getByIdProfissional(idProfissional)
                const cli = data.data

                console.log(cli?.profissional_agenda)
                setProfissional({
                    qntAtendHorario: cli?.qntAtendHorario.toString(),
                    qntEncaixe: cli?.qntEncaixe.toString(),
                    permiteAgendaOnline: cli?.permiteAgendaOnline.toString(),
                    diasSemanas: (cli?.profissional_agenda.length > 0) ? cli?.profissional_agenda : diasSemanasPadrao,
                    intervalo: (cli?.profissional_agenda.length > 0) ? cli?.profissional_agenda[0].intervalo : ''
                })
                setIsloading(false);
            }
            fetchData()
        } else {
            setIsloading(false);
        }

    }, [])

    const { fields: diasSemanasFields } = useFieldArray({ control, name: "diasSemanas" });

    console.log(profissional)
    //  console.log(diasSemanasFields)
    console.log(errors)
    return (
        <>

            <div className="box-fundo">
                <div style={{ maxWidth: '800px' }}>

                    {(isLoading) ? <Loading /> : (

                        <>
                            {(
                                (!listPermissoes?.cadastrar && !isLoadingPerm && idProfissional == null)
                                || (!listPermissoes?.editar && !isLoadingPerm && idProfissional != null)
                            ) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                                <>
                                    <h4 className="text-primary">Configuração de agenda</h4>
                                    <br></br>
                                    <Row>
                                        <Form.Group as={Col} sm={4}>
                                            <Form.Label> Qnt. de agendamentos por horário:</Form.Label>
                                            <Form.Control type="number"
                                                {...register('qntAtendHorario')} />
                                        </Form.Group>
                                        <Form.Group as={Col} sm={4}>
                                            <Form.Label> Intervalo da agenda:</Form.Label>
                                            <Form.Control type="number"
                                                {...register('intervalo')} />
                                        </Form.Group>
                                        {/*<Form.Group as={Col} sm={4}>
                                            <Form.Label> Qnt. de encaixe:</Form.Label>
                                            <Form.Control type="number" />
                                        </Form.Group>*/}
                                    </Row>
                                    <Row>
                                        <Form.Group as={Col}>
                                            <Form.Label className="mr-10">Habilita agendamento online?</Form.Label>
                                            <Form.Check
                                                inline
                                                id="chk0"
                                                type="radio"
                                                label="Não"
                                                value='0'
                                                {...register('permiteAgendaOnline')}
                                            ></Form.Check>
                                            <Form.Check
                                                inline
                                                id="chk1"
                                                type="radio"
                                                label="Sim"
                                                value='1'
                                                {...register('permiteAgendaOnline')}
                                            ></Form.Check>
                                        </Form.Group>

                                    </Row>

                                    {(diasSemanasFields != null) ? (
                                        <>
                                            <Row className="d-none d-md-flex" style={{ paddingTop: '5px', paddingBottom: '5px', borderBottom: '1px solid #fffbfbff', background: '#efefef' }}>
                                                <Form.Group as={Col} controlId="" xs={12} md={2}>
                                                    <Form.Label></Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                    <Form.Label>Início</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                    <Form.Label>Término</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                    <Form.Label>Habilitado?</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formNomeContato" xs={12} md={3}>
                                                </Form.Group>
                                            </Row>
                                        </>
                                    ) : ''}
                                    {diasSemanasFields?.map((campo, index) => (

                                        <Row style={{ paddingTop: '5px', paddingBottom: '5px', borderBottom: '1px solid #fffbfbff' }}>
                                            <Form.Group as={Col} controlId="" xs={12} md={2} className="text-center">
                                                <Form.Label>{campo?.dias_semanas?.nome}</Form.Label>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                <Form.Label className='d-md-none d-flex'>Início</Form.Label>
                                                <Controller
                                                    render={({ field }) => <input type="time" {...field} className="form-control" />}
                                                    name={`diasSemanas.${index}.inicio`}
                                                    control={control}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                <Form.Label className='d-md-none d-flex'>Término</Form.Label>
                                                <Controller
                                                    render={({ field }) => <input type="time" {...field} className="form-control" />}
                                                    name={`diasSemanas.${index}.termino`}
                                                    control={control}
                                                />
                                            </Form.Group >
                                            <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                <Form.Label className='d-md-none d-flex'>Habilitado?</Form.Label>
                                                <Controller
                                                    render={({ field }) => <select  {...field} className="form-select">
                                                        <option value="1">Sim</option>
                                                        <option value="0">Não</option>
                                                    </select>
                                                    }
                                                    name={`diasSemanas.${index}.status`}
                                                    control={control}
                                                />

                                            </Form.Group>
                                        </Row>
                                    ))}




                                    <br></br>
                                    <Alert variant={alert?.variant} show={alert?.msg != ''}>{alert?.msg}</Alert>



                                    <div className="text-center ">
                                        <Button variant="primary" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                            {(disableSalvar) ? <>
                                                <FontAwesomeIcon icon={["fas", "spinner"]} spin /> Salvando...
                                            </> : <>
                                                <FontAwesomeIcon icon={faFloppyDisk} className="mr-5" />
                                                Salvar
                                            </>}</Button>

                                    </div>
                                </>)}
                        </>)}
                </div>
            </div>

        </>
    )
}
export default ProfissionaisAgendaConfig